export default {
  MuiDialogActions: {
    root: {
      textAlign: 'right',
      padding: [0, 32, 32, 32],
    },
  },
};
